<template lang="pug">
section.container
    .tile.is-ancestor
        .tile.is-vertical.is-8
            .tile
                .tile.is-parent.is-vertical
                    article.tile.is-child.card.is-light(@click="openFilm(films[0].link)")
                      .card-image
                        figure.image
                          prismic-image(:field="films[0].thumbnail")
                      .card-content
                        .content
                          p.title.is-4 {{ films[0].title }}
                          p {{ films[0].description }}
                          b-button(type="is-danger")
                            span Watch on 
                            font-awesome-icon(:icon="['fab', 'youtube']")
                    article.tile.is-child.notification(@click="openArticle(articles[0].id)")
                        p.has-text-weight-bold.is-size-4 {{ articles[0].title }}
                        p.is-size-6 by {{ articles[0].author }}
                        br
                        b-taglist
                          b-tag(v-for="tag in articles[0].tags", type="is-link", rounded) {{ tag["tag"][0]["text"] }}
                        p {{ articles[0].description }}
                        br
                        b-button(type="is-dark") Read
                .tile.is-parent.is-vertical
                    article.tile.is-child.notification(@click="openArticle(articles[1].id)")
                        p.has-text-weight-bold.is-size-4 {{ articles[1].title }}
                        p.is-size-6 by {{ articles[1].author }}
                        br
                        b-taglist
                          b-tag(v-for="tag in articles[1].tags", type="is-link", rounded) {{ tag["tag"][0]["text"] }}
                        p {{ articles[1].description }}
                        br
                        b-button(type="is-dark") Read
                    article.tile.is-child.card.is-light(@click="openFilm(films[1].link)")
                      .card-image
                        figure.image
                          prismic-image(:field="films[1].thumbnail")
                      .card-content
                        .content
                          p.title.is-4 {{ films[1].title }}
                          p {{ films[1].description }}
                          b-button(type="is-danger")
                            span Watch on 
                            font-awesome-icon(:icon="['fab', 'youtube']")
            .tile.is-parent(@click="openVideo")
                article.tile.is-child.columns.is-vcentered.is-gapless.has-background-light
                  .column.is-one-half
                    figure.image
                      prismic-image(:field="video.thumbnail")
                  .column.is-one-half
                    .content.p-1
                      p.title.is-4 {{ video.title }}
                      p.subtitle.is-5 {{ video.description }}
                      b-button(type="is-danger")
                        span Watch on 
                        font-awesome-icon(:icon="['fab', 'youtube']")
        .tile.is-parent
            .tile.is-child.notification
                .content
                    p.title.is-4 Podcast
                    p.subtitle.is-5 Latest Episodes
                    .content
                      PodcastEpisode(v-for="podcast in podcasts", :podcast="podcast")
                      b-button(type="is-dark", tag="a", href="https://podcasts.apple.com/us/podcast/per-36/id1485406219", target="__blank", expanded) More
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";

library.add(faYoutube);

import PodcastEpisode from "@/components/PodcastEpisode.vue";

export default {
  name: "FrontPage",

  components: {
    PodcastEpisode
  },

  data() {
    return {
      articles: [],
      video: {},
      films: [],
      podcasts: []
    };
  },

  methods: {
    // Fetch articles from Prismic
    getArticles() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at("document.type", "article"), {
          orderings: "[my.article.date desc]",
          pageSize: 2
        })
        .then(response => {
          const results = response.results;
          this.articles = results.map(document => {
            return {
              id: document.id,
              title: document.data.title ? document.data.title[0].text : "",
              author: document.data.author ? document.data.author[0].text : "",
              image: document.data.image,
              date: document.data.date,
              tags: document.data.tags,
              description: document.data.description
                ? document.data.description[0].text
                : "",
              body: document.data.body
            };
          });
        });
    },

    // Get YouTube video id
    getVideoID(url) {
      const match = url.match(/^.*v=(.+)$/);
      if (match) {
        return match[1];
      }
    },

    // Fetch videos from Prismic
    getVideos() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at("document.type", "video"), {
          orderings: "[my.video.date desc]",
          pageSize: 1
        })
        .then(response => {
          const results = response.results;

          this.video = results.map(document => {
            return {
              title: document.data.title ? document.data.title[0].text : "",
              thumbnail: document.data.thumbnail,
              description:
                document.data.description !== undefined
                  ? document.data.description[0].text
                  : "",
              date: document.data.date,
              link: document.data.link ? document.data.link["url"] : "",
              embed: document.data.link
                ? this.getVideoID(document.data.link["url"])
                : ""
            };
          })[0];
        });
    },

    // Fetch films from Prismic
    getFilms() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at("document.type", "film"), {
          orderings: "[my.film.date desc]",
          pageSize: 2
        })
        .then(response => {
          const results = response.results;
          this.films = results.map(document => {
            return {
              title: document.data.title ? document.data.title[0].text : "",
              thumbnail: document.data.thumbnail,
              description:
                document.data.description !== undefined
                  ? document.data.description[0].text
                  : "",
              date: document.data.date,
              link: document.data.link ? document.data.link["url"] : "",
              embed: document.data.link
                ? this.getVideoID(document.data.link["url"])
                : ""
            };
          });
        });
    },

    // Fetch podcasts from Prismic
    getPodcasts() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at("document.type", "podcast"), {
          orderings: "[my.podcast.date desc]",
          pageSize: 10
        })
        .then(response => {
          const results = response.results;
          this.podcasts = results.map(document => {
            return {
              title: document.data.title[0].text,
              date: document.data.date,
              link: document.data.link["url"]
            };
          });
        });
    },

    // Open video
    openVideo() {
      window.open(this.video.link, "_blank");
    },

    // Open film
    openFilm(link) {
      window.open(link, "_blank");
    },

    // Open article
    openArticle(articleID) {
      this.$router.push({ path: `/article?id=${articleID}` });
    }
  },

  created() {
    this.getArticles();
    this.getVideos();
    this.getFilms();
    this.getPodcasts();
  }
};
</script>

<style lang="scss" scoped>
article {
  -webkit-filter: brightness(100%);
}

article:hover {
  -webkit-filter: brightness(70%);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
  cursor: pointer;
}
</style>
